import RequestService from '@/utils/service'
import WechatSdk from 'weixin-js-sdk'
import area from '@/area'
import { filterPicture } from '@/filters'

export default {
  state: {
    id: '',
    name: '',
    coupon: {},
    pullStream: '',
    pullStreamId: '',
    viewers: 0,
    status: '',
    prizeReceiveType: '',  // 【奖品领取方式】code: 核销，express: 快递，address: 领取地址

    readyImage: '',
    stopImage: '',
    doingImage: '',
    finishImage: '',

    giftsIcon: '',
    ticketsIcon: '',
    centraIcon: '',

    posterImage: '',  // 现在的背景图
    bannerUrl: '',  // 顶部轮播图

    addressList: [],

    officialNickname: '',

    luckyButtonVisible: false,
    buildingButtonVisible: false,

    customInfo: {}  // 定制化直播间
  },

  mutations: {
    setRoomInfo (state, detail) {
      state.id = detail.id
      state.name = detail.name
      state.coupon = detail.liveVoucher
      state.pullStream = detail.pullStreamUrl
      state.pullStreamId = detail.pullStreamName
      state.liveRecordVideo = detail.liveRecordVideo

      state.viewers = detail.viewers

      state.prizeReceiveType = detail.getPrizeWay  // code、express、address

      state.officialNickname = detail.officialName

      state.readyImage = detail.readyImage
      state.stopImage = detail.stopImage
      state.doingImage = detail.doingImage
      state.finishImage = detail.finishImage

      const iconArr = JSON.parse(detail.iconUrls) || []
      state.giftsIcon = iconArr[0] || ''
      state.ticketsIcon = iconArr[1] || ''
      state.centraIcon = iconArr[2] || ''

      state.luckyButtonVisible = detail.showPrize
      state.buildingButtonVisible = detail.showVoucher
      state.bannerUrl = detail.currentBannerUrl

      state.addressList = JSON.parse(detail.optionalAddress || '[]')  // 中奖领取地址

      // 如果没有定制化信息，则赋值公用信息
      state.customInfo = area[detail.id] || area.temp
    },

    setViewers (state, viewers) {
      state.viewers = viewers
    },

    setRoomStatus (state, status) {
      state.status = status

      switch (status) {
        case 'READY':
          state.posterImage = state.readyImage
          break
        case 'DOING':
          state.posterImage = state.doingImage
          break
        case 'STOP':
          state.posterImage = state.stopImage
          break
        case 'FINISH':
          state.posterImage = state.finishImage
          break
      }
    },

    setBannerUrl (state, url) {
      state.bannerUrl = url
    }
  },

  actions: {
    initRoom ({ commit }, data) {
      commit('setRoomInfo', data)
      commit('setRoomStatus', data.status)

      // 初始化 sdk
      RequestService({
        url: '/paltform/wx/mp/auth/getJsapiTicket',
        data: { appid: area.appId, url: window.location.href }
      }).then(res => {
        WechatSdk.config({
          appId: res.result.appId,
          timestamp: res.result.timestamp,
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'chooseWXPay']
        })
        
        const shareInfoArr = JSON.parse(data.shareInfo)
        const sharePicture = filterPicture(shareInfoArr[2])

        WechatSdk.ready(() => {
          WechatSdk.updateAppMessageShareData({
            title: shareInfoArr[0] || '',
            desc: shareInfoArr[1] || '',
            link: window.location.origin + '/dg3/room/' + data.id,
            imgUrl: sharePicture
          })

          WechatSdk.updateTimelineShareData({
            title: shareInfoArr[0] || '',
            link: window.location.origin + '/dg3/room/' + data.id,
            imgUrl: sharePicture
          })
        })
      })
    }
  }
}